import React from 'react';
import { LOGOS } from '../../constants/assets';

const Logo = ({ className = '', collapsed = false }) => {
  return (
    <div className={`overflow-hidden flex items-center justify-center ${className}`}>
      {collapsed ? (
        <div className="w-8 h-8 bg-brand-primary rounded-lg flex items-center justify-center text-white font-bold text-xl">
          R
        </div>
      ) : (
        <img 
          src={LOGOS.main} 
          alt="Resources & Manpower" 
          className="w-full h-full object-contain"
        />
      )}
    </div>
  );
};

export default Logo;